"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var Check_1 = __importDefault(require("@material-ui/icons/Check"));
var Close_1 = __importDefault(require("@material-ui/icons/Close"));
var React = __importStar(require("react"));
var styles_1 = require("../styles");
exports.Unchecked = (React.createElement("span", { className: 'unchecked' },
    React.createElement(Check_1.default, { style: {
            fill: styles_1.palette['white-base'],
            padding: 2,
            transform: 'scale(0)',
            transition: styles_1.transition
        } })));
exports.Checked = (React.createElement("span", { className: 'checked' },
    React.createElement(Check_1.default, { style: {
            fill: styles_1.palette['white-base'],
            padding: 2,
            transform: 'scale(1)',
            transition: styles_1.transition
        } })));
exports.RemoveTag = (React.createElement("span", { style: {
        height: 16,
        width: 16,
        borderRadius: 8,
        backgroundColor: styles_1.palette['white-base']
    } },
    React.createElement(Close_1.default, null)));
//# sourceMappingURL=Icons.js.map